/* eslint-disable camelcase */
export var plTranslations = {
    welcomePage: {
        ribbon: 'NOWOŚĆ',
        heroSection: {
            title: 'Elastyczne finansowanie <0></0>dla Twojego biznesu',
            features: {
                additionalFunds: {
                    title: 'Dodatkowe środki',
                    description: 'na rozwój Twojego biznesu lub inny dowolny cel.',
                },
                minimumFormalities: {
                    title: 'Minimum formalności',
                    description: 'wszystko załatwisz online, a umowę zatwierdzisz kodem SMS.',
                },
                quickProcess: {
                    title: 'Szybki proces',
                    description: 'do którego masz łatwy dostęp w panelu Przelewy24. Wybierz kwotę, zatwierdź swoje dane i gotowe.',
                },
                automaticRepayments: {
                    title: 'Automatyczne spłaty',
                    description: 'Nie musisz pamiętać o spłacie, następuje ona automatycznie z obrotów generowanych na Twoich kontach w Przelewy24.',
                },
            },
            featuresLiberis: {
                fastAndNoGuarantors: {
                    title: 'Prosto i bez <0 />poręczycieli',
                    description: 'Wystarczą 4 miesiące współpracy, by uzyskać finansowanie – bez dodatkowych zabezpieczeń.',
                },
                yourMoneyYourDecision: {
                    title: 'Twoje pieniądze, <0 />Twoja decyzja',
                    description: 'Pełna swoboda w wykorzystaniu środków. Decydujesz Ty!',
                },
                flexibilityRepayments: {
                    title: 'Spłaty dopasowane do <0 />wielkości Twojego biznesu',
                    description: 'Stały % spłat dostosowany do Twoich obrotów w Przelewy24',
                },
                automaticRepayments: {
                    title: 'Należności? <0 />Spłacają się same',
                    description: 'Pobieramy je automatycznie z Twoich obrotów. Bez zmartwień.',
                },
            },
            preLimit0: {
                title: 'Elastyczne finansowanie dla Twojego biznesu - ',
                subtitle: 'krok po kroku:',
                features: {
                    onlineApplication: {
                        title: 'Złóż wniosek online',
                        description: 'Bez wychodzenia z domu, wypełnij prosty formularz. Podaj kwotę finansowania, uzupełnij swoje dane i zaakceptuj wniosek.',
                    },
                    companyVerification: {
                        title: 'Weryfikacja firmy',
                        description: 'Opiekun PragmaGO skontaktuje się z Tobą, aby przeprowadzić Cię przez proces weryfikacji Twojej firmy.',
                    },
                    positiveDecision: {
                        title: 'Pozytywna decyzja',
                        description: 'W ciągu 48 godzin otrzymasz decyzję o przyznaniu limitu finansowania.',
                    },
                    panelLimitActivation: {
                        title: 'Aktywacja limitu w panelu Przelewy24',
                        description: 'Informacja o przyznanym limicie pojawi się automatycznie w Twoim panelu użytkownika.',
                    },
                    loanApplying: {
                        title: 'Wnioskowanie o finansowanie',
                        description: 'Możesz teraz złożyć wniosek o finansowanie w ramach przyznanego limitu.',
                    },
                },
            },
        },
        providerCard: {
            additionalFunds: 'Dodatkowe środki',
            forDevelopYourBusiness: 'na rozwój Twojego biznesu lub inny dowolny cel.',
            everythingYouCanGetDoneOnline: 'Wszystko załatwisz online, a umowę zatwierdzisz kodem SMS.',
            button: 'Przejdź do wniosku',
        },
        newPossibilitiesSection: {
            title: {
                newPossibilities: 'Nowe możliwości',
                financing: 'finansowania',
                forYourCompany: 'dla Twojej firmy.',
            },
            evenTo: 'Nawet do',
        },
        p24MarketingForm: {
            letStayInTouch: 'Bądźmy w kontakcie',
            description: 'Wyrażam zgodę na otrzymywanie od PayPro S.A. informacji handlowych, w tym dotyczących produktów i usług partnerów biznesowych PayPro S.A., za pośrednictwem komunikacji elektronicznej.',
            fields: {
                selectAll: 'zaznacz wszystkie',
                email: 'e-mail',
                sms: 'sms',
                phone: 'telefon',
            },
            agreementCancellation: 'W każdej chwili możesz zrezygnować z otrzymywania informacji w poszczególnych kanałach',
            administratorInfo: 'Administratorem danych osobowych jest PayPro S.A',
            readMore: 'Czytaj całość',
            privacyDetails: {
                title: 'Administratorem danych osobowych jest PayPro S.A., z którym można skontaktować się pod adresem iod@przelewy24.pl. Twoje dane osobowe będą przetwarzane w celu udzielenia odpowiedzi na kierowane do nas pytania za pośrednictwem powyższego formularza oraz przesyłania informacji marketingowych. W związku z przetwarzaniem danych osobowych przysługuje Ci prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania, wycofania zgody oraz złożenia skargi do Prezesa Urzędu Ochrony Danych Osobowych.',
                link: 'Szczegółowe informacje na temat ochrony danych',
            },
            buttonText: 'WEŹ POŻYCZKĘ',
        },
        loanApplicationPossible: {
            proceedToApplication: {
                buttonText: 'WEŹ POŻYCZKĘ',
                buttonTextSpecialOffer: 'SKORZYSTAJ Z OFERTY SPECJALNEJ',
            },
            liberis: {
                amountForm: {
                    howMuchDoYouWantToBorrow: 'Na jaką kwotę chcesz zawnioskować?',
                    buttonText: 'Przejdź do wniosku',
                    title: {
                        newPossibilities: 'Nowe możliwości',
                        financing: 'finansowania',
                        forYourCompany: 'dla Twojej firmy.',
                    },
                },
                checkYourData: {
                    title: 'Sprawdź swoje dane',
                    buttonText: 'Uzupełnij dane',
                    warningText: 'Uzupełnij swoje dane o numer telefonu, na który prześlemy kod SMS potrzebny do zaakceptowania umowy.',
                    fields: {
                        documentId: 'Seria i nr dokumentu',
                        phone: 'Numer telefonu',
                        mail: 'Adres email',
                    },
                    fieldsErrors: {
                        documentId: 'brak serii i nr dokumentu',
                        phone: 'brak nr telefonu',
                        mail: 'brak adres email',
                    },
                },
                agreementsForm: {
                    title: {
                        seeFullOffer: 'Zobacz pełną ofertę',
                        loans: 'finansowania',
                    },
                    multiprovider: {
                        title: 'Szukasz większego finansowania? Zyskaj do <0>{{ amount }}</0> z Liberis',
                    },
                    subtitle: 'Zaznacz poniższe zgody, aby otrzymać pełną ofertę finansowania od Liberis.',
                    subtitleMultiprovider: 'Zaznacz zgody, aby zobaczyć więcej ofert – <0>nawet 3 dodatkowe opcje.</0>',
                    buttonText: 'Przejdź do wniosku',
                    buttonTextMultiprovider: 'Idę dalej',
                    agreements: {
                        bureau: 'Kontynuując składanie wniosku, rozumiesz, że Liberis udostępni informacje podane w formularzu agencjom zajmującym się oceną zdolności kredytowej i zapobieganiem oszustwom w celu przeprowadzenia odpowiednich kontroli dotyczących przedsiębiorstwa(-w) i osoby(-ób) wskazanych w niniejszym wniosku. Więcej informacji o tym, jak Twoje dane będą wykorzystywane i udostępniane, znajduje się tutaj: <0>https://www.liberis.com/privacy-policy</0>',
                        marketing: '(Opcjonalnie) Wyrażam zgodę na kontaktowanie się ze mną telefonicznie przez Liberis w celu przedstawienia informacji handlowych i marketingowych dotyczących ich produktów i usług, w tym ofert finansowania oraz usług partnerów Liberis. Lista partnerów Liberis jest dostępna tutaj: <0>https://www.liberis.com/</0>. <br /> Zgoda obejmuje wykorzystanie mojego numeru telefonu podanego w formularzu. Zgoda jest dobrowolna i może zostać wycofana w dowolnym momencie.',
                        payProToLiberisData: {
                            title: 'Zgoda na przekazywanie danych przez PayPro S.A.',
                            content: 'Wyrażam zgodę na przekazanie przez PayPro S.A. z siedzibą w Poznaniu  do Liberis Sweden AB, Artillerigatan 8, 114 51 Sztokholm, Szwecja (numer rejestracyjny: 559205-5494; dalej: „Liberis”) następujących informacji stanowiących jednocześnie dane osobowe, tajemnicę zawodową dostawców usług płatniczych w rozumieniu ustawy o usługach płatniczych i tajemnicę przedsiębiorstwa w rozumieniu ustawy o zwalczaniu nieuczciwej konkurencji, dotyczących łączącej mnie z PayPro S.A. umowy ramowej oraz innych umów, których przedmiotem jest świadczenie usług płatniczych w tym acquringu („Umowa Ramowa”), a także aneksów i porozumień do Umowy Ramowej: Umowy Ramowa, w tym aneksów i porozumień do Umowy Ramowej, a także informacji o sposobie ich wykonywania, danych na temat historii sprzedaży/obrotowych dostępnych w ramach narzędzi PayPro S.A., wysokości bieżących rozliczeń dokonywanych na podstawie Umowy Ramowej i powiązanych z nią aneksów lub porozumień, o wypowiedzeniu, wygaśnięciu lub rozwiązaniu Umowy Ramowej i powiązanych z nią aneksów lub porozumień, doręczeniu lub realizacji zajęcia wierzytelności w toku postępowania egzekucyjnego celem realizacji zobowiązań Liberis z tytułu zawartej umowy z Liberis (Umowy Zaliczki Gotówkowej dla Przedsiębiorstw) oraz danych reprezentantów przedsiębiorstwa i danych niezbędnych do weryfikacji przeprowadzanej przez Liberis, w celu prowadzenia z tobą komunikacji, dokonania wstępnej oceny możliwości świadczenia usług finansowania, zbierania danych na potrzeby zawarcia umowy z Liberis i przedstawienia jej warunków oraz przygotowania oferty nowych produktów finansowych świadczonych za pośrednictwem PayPro S.A. oraz przygotowania oferty nowych produktów finansowych świadczonych za pośrednictwem PayPro S.A. Upoważnienie udzielane jest na czas obowiązywania Umowy Ramowej i 12 miesięcy po zakończeniu współpracy w oparciu o Umowę Ramową.',
                        },
                        liberisDataToPayPro: {
                            title: 'Zgoda na przekazywanie danych przez Liberis Sweden AB',
                            content: 'Wyrażam zgodę na przekazanie przez Liberis Sweden AB, Artillerigatan 8, 114 51 Sztokholm, Szwecja (numer rejestracyjny: 559205-5494; dalej: „Liberis”) do PayPro S.A. następujących informacji dotyczących łączącej mnie z Liberis Umowy Zaliczki Gotówkowej dla Przedsiębiorstw, a także wszelkich aneksów i porozumień do tej umowy, a także informacji o sposobie jej wykonywania: oceny zdolności kredytowej dokonanej przez Liberis, wysokości nadanego Klientowi limitu finansowego, możliwości świadczenia usług finansowania na podstawie Umowy Zaliczki Gotówkowej dla Przedsiębiorstw, przyczynę odmowy świadczenia usług finansowania, zawarciu, zmianie, rozwiązaniu lub wygaśnięciu Umowy Zaliczki Gotówkowej dla Przedsiębiorstw oraz okolicznościach uzasadniających to zdarzenie lub towarzyszącym temu zdarzeniu celem ujawnienia ci tych danych w Systemie oraz realizacji Cesji. Upoważnienie udzielane jest na czas obowiązywania Umowy Zaliczki Gotówkowej dla Przedsiębiorstw i 6 miesięcy po zakończeniu współpracy w oparciu o Umowy Zaliczki Gotówkowej dla Przedsiębiorstw.',
                        },
                    },
                    disclaimer: 'Rozumiem, że mogę w każdej chwili wycofać wszystkie lub niektóre zgody, bez wpływu na zgodność z prawem przetwarzania',
                    disclaimerButton: 'Rozwiń',
                    additionalInfo: {
                        param1: 'Ten produkt jest oferowany przez Liberis Sweden AB, Artillerigatan 8, 114 51 Sztokholm, Szwecja (numer rejestracyjny: 559205-5494). Finansowanie oparte na przychodach od Liberis to forma finansowania należności, a nie pożyczka. Kwoty finansowania są uzależnione od statusu oraz procesu oceny ryzyka kredytowego, zanim zostanie złożona jakakolwiek oferta.',
                        param2: 'Oczekuje się, że będziesz prowadzić swoją działalność w sposób, który zapewni Liberis minimalną miesięczną spłatę w wysokości do 3% całkowitej należności wobec Liberis',
                        param3: {
                            sub1: 'Rozumiem, że mogę w każdej chwili wycofać wszystkie lub niektóre zgody, bez wpływu na zgodność z prawem przetwarzania, które miało miejsce przed ich wycofaniem.',
                            sub2: 'Mogę wycofać zgodę kontaktując się z Liberis pod adresem e-mail <0>info-pl@liberis.com</0> lub numerem telefonu: +48221036266, albo pisemnie, wysyłając zawiadomienie na adres siedziby Liberis: Artillerigatan 8, 114 51 Stockholm, Sweden.',
                            sub3: 'Tymi samymi kanałami mogę także zażądać informacji o przetwarzanych przez Liberis danych osobowych oraz żądać ich sprostowania, usunięcia, ograniczenia przetwarzania lub przeniesienia.',
                            sub4: 'Informacje handlowe (marketing bezpośredni produktów i usług Liberis) mogą przybierać formę spersonalizowanych komunikatów opartych na profilowaniu, które pozwala nam oferować produkty i usługi najlepiej dopasowane do Twoich preferencji i oczekiwań, uwzględniając wcześniejsze korzystanie z produktów i usług Liberis.',
                            sub5: 'Mam także prawo złożyć skargę do Prezesa Urzędu Ochrony Danych Osobowych, jeśli uważam, że Liberis narusza przepisy dotyczące ochrony danych osobowych.',
                            sub6: 'Więcej informacji o przetwarzaniu danych osobowych przez Liberis dostępnych jest tutaj: <0>https://www.liberis.com/privacy-policy</0>',
                        },
                    },
                },
                oneMoreFinancingOption: {
                    title: {
                        oneMoreOption: 'Jeszcze jedna opcja',
                        financing: 'finansowania',
                        forYourCompany: 'dla Twojej firmy.',
                    },
                    howMuchDoYouWantToBorrow: 'Na jaką kwotę chcesz zawnioskować?',
                    buttonText: 'Przejdź do wniosku',
                },
                companyData: {
                    title: 'Dane firmowe',
                    subtitle: 'Potwierdź lub edytuj główne miejsce prowadzenia działalności i rachunek bankowy',
                    buttonText: 'Potwierdzam i idę dalej',
                    form: {
                        street: 'Ulica i nr lokalu',
                        postCode: 'Kod pocztowy',
                        city: 'Miasto',
                        country: 'Kraj',
                        iban: 'Konto, na które wpłyną środki',
                        companyRegisterDate: 'Data rejestracji działalności',
                    },
                    disclaimer: 'Poniższe dane zostały wprowadzone podczas rejestracji konta w Przelewy24.',
                },
                beneficientData: {
                    subtitle: 'Potwierdź lub edytuj dane beneficjenta',
                    buttonText: 'Potwierdzam i idę dalej',
                    form: {
                        phoneNumber: 'Numer telefonu',
                        email: 'Adres email',
                        validation: {
                            phoneNumber: 'Nieprawidłowy numer telefonu',
                            email: 'Nieprawidłowy adres email',
                        },
                    },
                    mailingAddressLabel: 'Adres korespondencyjny',
                    partnershipForm: {
                        enterParticipationPercentage: 'Wpisz % udziału',
                        notSureOfParticipation: 'Nie wiesz jaki % udziału?',
                        lookIntoTheKRS: 'Zajrzyj do KRS',
                    },
                },
                addAddressData: {
                    title: 'Uzupełnij dane adresowe',
                    subtitle: 'beneficjentów rzeczywistych',
                    formSummary: 'Zapisz adres i przejdź do uzupełnienia adresu kolejnego beneficjenta.',
                    form: {
                        postCode: 'Kod pocztowy',
                        city: 'Miasto',
                        street: 'Ulica i numer lokalu',
                        country: 'Kraj',
                    },
                    buttonText: 'Zapisz i przejdź dalej',
                },
                noBeneficientData: {
                    title: 'Brak danych beneficjentów',
                    subtitle: 'Aby uzupełnić dane beneficjentów, kontaktuj się z <0>Biurem Obsługi Biznesu Przelewy24</0>',
                },
                noRepresentativeData: {
                    title: 'Brak danych reprezentantów',
                    subtitle: 'Aby uzupełnić dane reprezentantów, kontaktuj się z <0>Biurem Obsługi Biznesu Przelewy24</0>',
                },
                completeDataContact: {
                    receptionHours: '(w godz. 8:00-16:00)',
                    disclaimer: 'Twoje dane do wniosku o finansowanie są automatycznie pobierane z Panelu Przelewy24. Każda zmiana danych dotycząca Twojego konta w Przelewy24 będzie widoczna również w tym wniosku.',
                },
                validation: {
                    postCode: 'Nieprawidłowy format kodu, np.',
                    city: 'Niepoprawna nazwa miasta',
                    street: {
                        invalid: 'Niepoprawna nazwa ulicy lub numer',
                        tooShort: 'Za krótka nazwa ulicy',
                        tooLong: 'Za długa nazwa ulicy',
                    },
                    country: {
                        invalid: 'Niepoprawna nazwa kraju',
                        tooShort: 'Za krótka nazwa kraju',
                        tooLong: 'Za długa nazwa kraju',
                    },
                    phone: 'Wprowadź prawidłowy numer telefonu',
                    mail: {
                        invalid: 'Wprowadź prawidłowy adres email',
                        duplicate: 'Ten adres e‑mail został już wprowadzony. Wprowadź inny adres.',
                    },
                    address: {
                        unique: 'Ten adres został już wprowadzony. Wprowadź inny adres.',
                    },
                    companyRegisterDate: {
                        required: 'Data rejestracji jest wymagana.',
                        invalidFormat: 'Nieprawidłowy format daty. Wymagany format: RRRR-MM-DD.',
                        unrealisticDate: 'Data rejestracji jest nieprawdopodobna.',
                        invalidDate: 'Nieprawidłowa data. Sprawdź rok, miesiąc lub dzień.',
                        featureDate: 'Data rejestracji nie może być z przyszłości.',
                    },
                },
            },
        },
        loanApplicationLowerPrivilegeLevel: {
            condition: 'Usługa jest dostępna na koncie z wyższym poziomem uprawnień.',
            logout: 'Przeloguj się na konto z odpowiednim poziomem uprawnień.',
            buttonText: 'WEŹ POŻYCZKĘ',
        },
        serviceNotAvailable: {
            title: 'Przepraszamy,',
            subtitle: 'usługa chwilowo niedostępna.',
            description: 'Wróć za chwilę i złóż wniosek.',
            errorCode: 'Kod błędu',
        },
        userHasLessThan3000Prelimit: {
            title: 'Usługa niedostępna',
            description: 'Twoje obecne obroty generowane w Przelewy24 nie pozwalają na skorzystanie z usługi finansowania Pragma x Przelewy24 Finance.',
            conditions: 'Sprawdź, jakie warunki trzeba spełnić, aby uzyskać finansowanie',
            faq: 'FAQ',
        },
        userHasNoActiveAccount: {
            title: 'Usługa niedostępna',
            description: 'Twoje konto w Przelewy24 nie pozwala na skorzystanie z usługi finansowania Pragma x Przelewy24 Finance.',
            conditions: 'Sprawdź, jakie warunki trzeba spełnić, aby uzyskać finansowanie',
            faq: 'FAQ',
        },
        p24ContactForm: {
            title: 'Masz pytanie o usługę finansowania?',
            description: 'Napisz do nas, z chęcią udzielimy wszelkich informacji.',
            buttonText: 'Wyślij',
            messageSend: 'Wiadomość wysłana',
            messageSendError: 'Wiadomość nie wysłana',
            errorCode: 'Kod błędu',
            placeholder: 'Wpisz swoje pytanie',
            validation: {
                min: 'Pole obowiązkowe',
                max: 'Maksymalna długość wiadomości: 1000 znaków',
            },
        },
        userHasZeroPrelimit: {
            title: 'Na jaką kwotę',
            subtitle: 'chcesz zawnioskować?',
            marketingAgreementDescription: 'Wyrażam zgodę na przekazywanie przez PayPro S.A. treści marketingowych dotyczących PragmaGo S.A. wskazanym kanałem komunikacji. Wyrażam zgodę na przekazywanie przez PayPro S.A. treści marketingowych dotyczących PragmaGo S.A. wskazanym kanałem komunikacji:Wyrażam zgodę na przekazywanie przez PayPro S.A. treści marketingowych dotyczących PragmaGo S.A. wskazanym kanałem komunikacji. Wyrażam zgodę na przekazywanie przez PayPro S.A. treści marketingowych dotyczących PragmaGo S.A. wskazanym kanałem komunikacji',
            dataProcessingLink: 'Link do szczegółów przetwarzania danych.',
        },
        specialOfferSection: {
            specialOffer: 'Oferta specjalna',
            limitedQuantity: 'Ograniczona pula!',
            title: {
                forGrowthYourCompany: 'Na rozwój Twojej firmy',
                with: 'z',
                interestRate: 'oprocentowaniem',
                only: 'tylko',
            },
            countdownWrapper: {
                title: 'Oferta ważna jeszcze tylko',
                disclaimer: '*lub do wyczerpania puli środków',
            },
            limitedFundingPoolWrapper: {
                title: 'Ograniczona pula środków',
            },
            variant3: {
                title: 'na rozwój Twojej firmy z oprocentowaniem tylko',
            },
        },
    },
    loanFormPage: {
        advanceAmount: {
            title: 'Wybierz kwotę',
            description: 'Skorzystaj z suwaka lub wpisz poniżej wartość liczbową.',
            min: 'min',
            max: 'max',
            secondDescription: {
                maxAmount: 'Wybierając czas spłaty {{months}} możesz zawnioskować maksymalnie o: {{amount}} PLN',
                basedOnTurnover: 'Wyliczono na podstawie obrotów w Przelewy24',
            },
            maxAmountExceed: 'Maksymalna kwota o jaką możesz zawnioskować, to {{max}} zł',
            minAmountFallShort: 'Minimalna kwota o jaką możesz zawnioskować, to {{min}} zł',
            specialOffer: 'Oferta specjalna',
            starter: 'STARTER',
        },
        interestRateInformation: {
            title: 'Rzeczywista Roczna Stopa Oprocentowania (RRSO) dla przykładowego wniosku o finansowanie wynosi 9,99%.',
            description: 'Ta wartość reprezentuje całkowity koszt finansowania wyrażony w procentach rocznie i uwzględnia wszystkie obligatoryjne opłaty związane z finansowaniem, w tym oprocentowanie, prowizje, opłaty administracyjne i inne koszty. Przykład reprezentatywny: dla wniosku o finansowanie w wysokości 10 000 zł na okres 24 miesięcy, z oprocentowaniem nominalnym 8%, całkowita kwota do zapłaty 10 800 zł. RRSO wynosi 9,99%.',
        },
        financingProvides: 'Finansowanie zapewnia',
        borrowerDetails: {
            title: 'Sprawdź swoje dane',
            form: {
                fields: {
                    name_surname: 'Imię i Nazwisko',
                    pesel: 'Nr PESEL',
                    documentId: 'Seria i nr dokumentu',
                    phone: 'Numer telefonu',
                    mail: 'Adres email',
                    taxId: 'NIP',
                    bankAccount: 'Rachunek bankowy, na który wpłyną środki',
                    companyName: 'Nazwa firmy',
                },
                validation: {
                    mail: 'Wprowadź prawidłowy adres email',
                    lettersOnly: 'Proszę podać tylko litery',
                    phone: 'Wprowadź prawidłowy numer telefonu',
                    documentNumber: 'Seria i numer dokumentu są nieprawidłowe',
                    documentType: 'Typ dokumentu jest nieprawidłowy',
                    nameSurname: 'Nieprawidłowe imię i nazwisko',
                },
                editFieldValues: {
                    phone: 'Zmień nr telefonu',
                    mail: 'Zmień adres emailowy',
                    documentId: 'Zmień serię i nr dokumentu',
                    documentType: 'Zmień typ dokumentu',
                },
                addFieldValues: {
                    phone: 'Dodaj nr telefonu',
                    mail: 'Dodaj adres email',
                    documentId: 'Dodaj serię i nr dokumentu',
                    documentType: 'Dodaj typ dokumentu',
                },
            },
        },
        recipientDetails: {
            header: 'Jak edytować formularz?',
            dataInfo: 'Twoje dane do wniosku o finansowanie są automatycznie pobierane z Panelu Przelewy24. Każda zmiana danych dotycząca Twojego konta w Przelewy24 będzie widoczna również w tym wniosku.\n',
            phoneNumber: 'Numer telefonu: zaktualizuj go w Panelu Przelewy24',
            emailAddress: 'Adres e-mail: zaktualizuj go w Panelu Przelewy24',
            personalData: 'Dane osobowe – skontaktuj się z Biurem Obsługi Biznesu Przelewy24',
            contactByMail: 'Mailowo:',
            contactByPhone: 'lub telefonicznie:',
            hours: 'w godz. 8:00-16:00',
        },
        agreements: {
            form: {
                fields: {
                    representative: {
                        title: 'Potwierdzam, że jestem umocowana/y do składania w imieniu przedsiębiorcy oświadczeń woli w zakresie podanym na wniosku oraz*',
                        content: 'Potwierdzam, że jestem umocowana/y do składania w imieniu przedsiębiorcy oświadczeń woli w zakresie podanym w tym wniosku oraz dotyczących Umowy Pożyczki - PragmaGO x Przelewy24 Finance, Regulaminu Pożyczki - PragmaGO x Przelewy24 Finance oraz Regulaminu świadczenia usług przez PragmaGO S.A. oraz oświadczam że numer telefonu wskazany w tym wniosku należy do mnie.',
                    },
                    loanTerms: {
                        title: 'Akceptuję <0>Regulamin Pożyczki – PragmaGO x Przelewy24 Finance</0>',
                        content: 'Akceptuję <0>Regulamin Pożyczki - PragmaGO x Przelewy24 Finance</0>, w tym także rozumiem, że dane rejestrowe i handlowe mojego konta i kont powiązanych, dostępne w serwisie PayPro S.A., będą na bieżąco przekazywane do PragmaGO S.A. jako kolejnemu administratorowi, co jest niezbędne do zawierania i wykonywania umów z PragmaGO S.A., na co wyrażam zgodę.',
                    },
                    pragmaTerms: {
                        title: 'Akceptuję <0>Regulamin świadczenia usług przez PragmaGO S.A.</0>',
                        content: 'Akceptuję <0>Regulamin świadczenia przez PragmaGO S.A.</0> usług finansowych w serwisie PragmaGO.pl oraz Regulamin świadczenia przez PragmaGO usług finansowania w ramach Umowy Pożyczki - PragmaGO x Przelewy24 Finance, a także rozumiem, że moje dane, udostępnione przez P24, będą analizowane przez PragmaGO S.A. w tym z wykorzystanie wymienionych tutaj ogólnodostępnych źródeł w celu przyznania limitu kredytowego.',
                    },
                    bikbig: {
                        title: 'Zgadzam się na weryfikację moich danych w BIK i BIG w zakresie widocznym w pełnej treści upoważnienia',
                        content: {
                            paragraph1: 'a) Przekazanie przez PragmaGO S.A. do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie moich danych osobowych (zapytanie) w celu pozyskania informacji, w tym  stanowiących tajemnicę bankową dotyczących mnie jako przedsiębiorcy, a także dotyczących mnie jako osoby fizycznej – konsumenta, przetwarzanych w Biurze Informacji Kredytowej S.A. dla oceny zdolności kredytowej i analizy ryzyka kredytowego oraz przetwarzanie w tym celu przez Biuro Informacji Kredytowej S.A. moich danych osobowych przekazanych przez PragmaGO S.A.  w zapytaniu, przez okres nie dłuższy niż 2 lata, w tym ich udostępnianie w tym ich udostępnianie bankom, instytucjom ustawowo upoważnionym do udzielania kredytów, instytucjom kredytowym oraz innym podmiotom na podstawie udzielonej im przeze mnie zgody.',
                            paragraph2: 'b) Przekazywanie przez PragmaGO S.A.  do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie informacji dotyczących  mojego zobowiązania wynikającego z zawartej z PragmaGO S.A. umowy, oraz przetwarzanie tych informacji przez Biuro Informacji Kredytowej S.A. do dnia odwołania zgody, nie dłużej jednak niż 5 lat po wygaśnięciu zobowiązania w celu oceny zdolności kredytowej i analizy ryzyka kredytowego, w tym ich udostępnianie bankom, instytucjom ustawowo upoważnionym do udzielania kredytów, instytucjom kredytowym oraz innym podmiotom na podstawie udzielonej im przeze mnie zgody. Niniejsza zgoda obejmuje również udostępnianie PragmaGO S.A.  przez Biuro Informacji Kredytowej S.A. informacji, w tym stanowiących tajemnice bankową dotyczących prowadzonej przeze mnie działalności gospodarczej przetwarzanych w Biurze Informacji Kredytowej S.A. dla oceny zdolności kredytowej i analizy ryzyka kredytowego w trakcie obowiązywania zawartej z PragmaGO S.A.  umowy.',
                            paragraph3: 'c) Przekazanie przez PragmaGO S.A.  do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie moich danych osobowych, oraz przetwarzanie tych danych przez Biuro Informacji Kredytowej S.A. do dnia odwołania zgody, w celu oceny zdolności kredytowej i analizy ryzyka kredytowego, w tym ich udostępnianie bankom, instytucjom ustawowo upoważnionym do udzielania kredytów, instytucjom kredytowym oraz innym podmiotom na podstawie udzielonej im przeze mnie zgody.',
                            paragraph4: 'd) Oraz upoważniam PragmaGO S.A. do uzyskania informacji gospodarczych z Biura Informacji Gospodarczej InfoMonitor SA oraz do pozyskania z BIG InfoMonitor informacji dotyczących składanych zapytań na mój temat do Rejestru BIG InfoMonitor w ciągu ostatnich 12 miesięcy, na potrzeby realizacji wniosku i dokonania analizy finansowej.',
                            paragraph5: 'e) Potwierdzam, że zostałam(em) poinformowana(y) o prawie  do odwołania powyższych zgód w każdym czasie. Przyjmuję do wiadomości, że odwołanie zgody nie wpływa na zgodność z prawem przetwarzania danych przed wycofaniem zgody.',
                            paragraph6: 'Jeżeli wyrazicie Państwo powyższe zgody, PragmaGO będzie dodatkowo przetwarzać informacje dotyczące Państwa sytuacji finansowej, pochodzące z Biura Informacji Kredytowej SA. w celu podjęcia działań niezbędnych do rozpatrzenia wniosku o zawarcie umowy oraz w celu zarządzania ryzykiem i dokonania oceny zdolności kredytowej. W powyższym przypadku odbiorcą Państwa danych osobowych może być dodatkowo Biuro Informacji Kredytowej SA.',
                            paragraph7: 'Więcej informacji: <0>{{link}}</0>',
                            paragraph8: 'Jeżeli wyrazicie Państwo powyższą zgodę, PragmaGO oraz Pragma Faktor Sp. z o.o. działający jako indywidualni administratorzy będą dodatkowo przetwarzać informacje gospodarcze dotyczące Państwa, pochodzące od Biura Informacji Kredytowej SA i zgromadzone w bazach tego podmiotu, w celu podjęcia działań niezbędnych do rozpatrzenia wniosku o zawarcie umowy w związku z zarządzaniem ryzykiem i koniecznością dokonywania oceny zdolności kredytowej, w szczególności oceny ryzyka braku płatności, opóźnień w płatnościach ze strony odbiorców (na podstawie art. 6 ust. 1 lit. f) RODO, czyli dla realizacji prawnie uzasadnionych interesów administratora danych w postaci zarządzania ryzykiem związanym z finansowaniem i realizacją umowy), przez czas niezbędny do podjęcia decyzji o zawarciu umowy, do czasu zawarcia umowy lub do czasu zerwania negocjacji w sprawie zawarcia umowy, a w przypadku zawarcia umowy – przez czas trwania zawartej umowy.',
                            paragraph9: 'W powyższym przypadku odbiorcą Państwa danych osobowych może być dodatkowo Biuro Informacji Kredytowej SA jako podmiot udostępniający informacje o wiarygodności płatniczej.',
                            paragraph10: 'Nadto jeżeli wyrazicie Państwo powyższą zgodę, PragmaGO będzie dodatkowo przetwarzać informacje gospodarcze dotyczące Państwa, pochodzące od Biura Informacji Gospodarczej InfoMonitor S.A., w celu podjęcia działań niezbędnych do rozpatrzenia wniosku o zawarcie umowy oraz w celu zarządzania ryzykiem i dokonania oceny zdolności kredytowej. W powyższym przypadku odbiorcą Państwa danych osobowych może być dodatkowo Biuro Informacji Gospodarczej InfoMonitor S.A.',
                            paragraph11: 'Więcej informacji: <0>{{link}}</0>',
                            paragraph12: 'Jeżeli wyrazicie Państwo powyższą zgodę, PragmaGO będzie dodatkowo przetwarzać informacje gospodarcze dotyczące Państwa Firmy, pochodzące od Biura Informacji Gospodarczej InfoMonitor S.A. i zgromadzone w bazach tego podmiotu, w celu podjęcia działań niezbędnych do rozpatrzenia wniosku o zawarcie umowy w związku z zarządzaniem ryzykiem i koniecznością dokonywania oceny zdolności kredytowej zdolności kredytowej, w szczególności oceny ryzyka braku płatności, opóźnień w płatnościach ze strony odbiorców, w tym z wykorzystaniem automatycznego przetwarzania danych (na podstawie art. 6 ust. 1 lit. f) RODO, czyli dla realizacji prawnie uzasadnionych interesów PragmaGO jako administratora danych w postaci zarządzania ryzykiem związanym z finansowaniem i realizacją umowy), przez czas niezbędny do podjęcia decyzji o zawarciu umowy, do czasu zawarcia umowy lub do czasu zerwania negocjacji w sprawie zawarcia umowy, a w przypadku zawarcia umowy – przez czas trwania zawartej umowy.',
                            paragraph13: 'W powyższym przypadku odbiorcą Państwa danych osobowych może być dodatkowo Biuro Informacji Gospodarczej InfoMonitor S.A. jako podmiot udostępniający informacje o wiarygodności płatniczej.',
                            paragraph14: 'Pani/Pana dane osobowe będą przetwarzane przez BIG InfoMonitor S.A..; kontakt: adres e-mail <0>{{emailInfoBig}}</0> lub pisemnie (adres siedziby). Kontakt z inspektorem ochrony danych: adres e-mail <1>{{emailIodBig}}</1> lub pisemnie (adres siedziby Administratora) w celu udostępnienia informacji dotyczących zapytań. Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych, prawo żądania ich sprostowania, a w sytuacjach przewidzianych przepisami także prawo do usunięcia, ograniczenia przetwarzania, wyrażenia sprzeciwu wobec ich przetwarzania lub wycofania zgody, na podstawie której Pani/Pana dane są przetwarzane oraz przenoszenia danych. Przysługuje Pani/Panu również prawo wniesienia skargi do organu nadzorczego.',
                            paragraph15: 'Więcej informacji: <0>{{link}}</0>',
                            paragraph16: 'Administratorem Pani/Pana danych osobowych jest BIG InfoMonitor S.A.. Z Administratorem można się skontaktować poprzez adres e-mail: <0>{{emailInfoBig}}</0> lub pisemnie (adres siedziby Administratora).',
                            paragraph17: 'Wyznaczony został inspektor ochrony danych, z którym można się skontaktować poprzez adres poczty elektronicznej: <0>{{emailIodBig}}</0> lub pisemnie (adres siedziby Administratora). Z inspektorem ochrony danych można się kontaktować we wszystkich sprawach dotyczących przetwarzania danych osobowych oraz korzystania z praw związanych z przetwarzaniem danych.',
                            paragraph18: 'Pani/Pana dane będą przetwarzane przez BIG InfoMonitor w celu udostępnienia informacji dotyczących zapytań, na podstawie Pani/Pana zgody, będącej podstawą przetwarzania Pani/Pana danych osobowych.',
                            paragraph19: 'BIG InfoMonitor przetwarza Pani/Pana dane osobowe w zakresie: nazwa, nr NIP.',
                            paragraph20: 'Odbiorcami Pani/Pana danych osobowych mogą być firmy zajmujące się obsługą systemów teleinformatycznych lub świadczeniem innych usług IT na rzecz BIG InfoMonitor, w zakresie niezbędnym do realizacji celów, dla których przetwarzane są te dane.',
                            paragraph21: 'Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych oraz prawo żądania ich sprostowania, usunięcia, ograniczenia przetwarzania. W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest przesłanka prawnie uzasadnionego interesu Administratora, przysługuje Pani/Panu prawo wniesienia sprzeciwu wobec przetwarzania Pani/Pana danych osobowych.',
                            paragraph22: 'W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest zgoda, ma Pani/Pan prawo wycofania zgody. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.',
                            paragraph23: 'W zakresie, w jakim Pani/Pana dane są przetwarzane na podstawie zgody przysługuje Pani/Panu także prawo do przenoszenia danych osobowych, tj. do otrzymania od Administratora Pani/Pana danych osobowych, w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego. Może Pani/Pan przesłać te dane innemu administratorowi danych. Uprawnienie do przenoszenia danych nie dotyczy danych, które stanowią tajemnicę przedsiębiorstwa Wierzyciela.',
                            paragraph24: 'Przysługuje Pani/Panu również prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych.',
                        },
                    },
                    professionalContract: {
                        title: 'Oświadczam, że umowa ma dla mnie charakter zawodowy',
                        content: 'Oświadczam, że działam jako przedsiębiorca, a niniejsza umowa ma dla mnie charakter zawodowy, zaś udzielone finansowanie będzie wykorzystywane wyłącznie na cele związane bezpośrednio z prowadzoną przeze mnie działalnością gospodarczą i zawodową. Potwierdzam, że wiadomym mi jest, iż oferta PragmaGO S.A. jest kierowana wyłącznie do przedsiębiorców.',
                    },
                    marketing: {
                        content: '(Opcjonalnie) Wyrażam zgodę na dostarczanie mi drogą elektroniczną informacji handlowych od PragmaGO S.A. w związku z wyrażoną przeze mnie chęcią zawarcia Umowy Pożyczki - PragmaGO x Przelewy24 Finance.',
                    },
                    payproDataProcessing: {
                        title: 'Upoważniam PayPro S.A i / lub . Polskie ePłatności sp. z o.o. do przekazywania danych do PragmaGO S.A.',
                        content: 'Upoważniam podmioty, z którymi wiąże mnie umowa o świadczenie usług płatniczych, to jest PayPro S.A. z siedzibą w Poznaniu i / lubPolskie ePłatności sp. z o.o. z siedzibą w Rzeszowie , do przekazywania do PragmaGO S.A. z siedzibą w Katowicach:\n\n 1. wszelkich informacji dotyczących łączącej mnie z PayPro S.A. z siedzibą w Poznaniu Umowy Ramowej oraz innych umów, których przedmiotem jest świadczenie usług płatniczych w tym acquringu („Umowa Ramowa”), a także aneksów i porozumień do Umowy Ramowej: Umowy Ramowa, w tym aneksów i porozumień do Umowy Ramowej, w tym w szczególności informacji stanowiących jednocześnie dane osobowe, tajemnicę zawodową dostawców usług płatniczych w rozumieniu ustawy o usługach płatniczych i tajemnicę przedsiębiorstwa w rozumieniu ustawy o zwalczaniu nieuczciwej konkurencji obejmujących warunki Umowy Ramowej oraz aneksów i porozumień do Umowy Ramowej, a także informacji o sposobie ich wykonywania, danych na temat historii sprzedaży/obrotowych dostępnych w ramach narzędzi PayPro S.A., informacji o złożeniu dyspozycji wypłaty środków na rachunek PragmaGO S.A. z siedzibą w Katowicach, wysokości bieżących rozliczeń dokonywanych na podstawie Umowy Ramowej i powiązanych z nią aneksów lub porozumień, o wypowiedzeniu, wygaśnięciu lub rozwiązaniu Umowy Ramowej i powiązanych z nią aneksów lub porozumień, doręczeniu lub realizacji zajęcia wierzytelności w toku postępowania egzekucyjnego celem realizacji zobowiązań PragmaGO z tytułu zawartej Umowy Pożyczki - PragmaGO x Przelewy24 Finance, prowadzenia z Tobą komunikacji, dokonania wstępnej oceny możliwości świadczenia usług finansowania, zbierania danych na potrzeby zawarcia Umowy Pożyczki - PragmaGO x Przelewy24 Finance i przedstawienia jej warunków oraz przygotowania oferty nowych produktów finansowych świadczonych za pośrednictwem PayPro S.A. oraz przygotowania oferty nowych produktów finansowych świadczonych przez pośrednictwem PayPro S.A.. Upoważnienie udzielane jest na czas obowiązywania Umowy Ramowej i 12 miesięcy po zakończeniu współpracy w oparciu o Umowę Ramową.\n\ni / lub\n\n2. wszelkich informacji dotyczących łączącej mnie z Polskie ePłatności sp. z o.o. z siedzibą w Rzeszowie  Umowy o przyjmowanie zapłaty dokonywanej przy pomocy instrumentów płatniczych lub umowy ramowej na świadczenie usług na terminalach płatniczych („Umowa PLAT”), a także aneksów i porozumień do Umowy PLAT, w tym w szczególności informacji stanowiących jednocześnie dane osobowe, tajemnicę zawodową dostawców usług płatniczych w rozumieniu ustawy o usługach płatniczych i tajemnicę przedsiębiorstwa w rozumieniu ustawy o zwalczaniu nieuczciwej konkurencji obejmujących warunki Umowy PLAT oraz aneksów i porozumień do Umowy PLAT, informacji o sposobie ich wykonywania, danych na temat historii sprzedaży/obrotowych dostępnych w ramach narzędzi PeP, informacji o złożeniu dyspozycji wypłaty środków na rachunek PragmaGO S.A. z siedzibą w Katowicach, wysokości bieżących rozliczeń dokonywanych na podstawie Umowy PLAT i powiązanych z nią aneksów lub porozumień, o wypowiedzeniu, wygaśnięciu lub rozwiązaniu Umowy PLAT i powiązanych z nią aneksów lub porozumień, doręczeniu lub realizacji zajęcia wierzytelności w toku postępowania egzekucyjnego celem realizacji zobowiązań PragmaGO z tytułu zawartej Umowy Pożyczki, prowadzenia z Tobą komunikacji, dokonania wstępnej oceny możliwości świadczenia usług finansowania, zbierania danych na potrzeby zawarcia Umowy Pożyczki i przedstawienia jej warunków oraz przygotowania oferty nowych produktów finansowych świadczonych za pośrednictwem PeP oraz przygotowania oferty nowych produktów finansowych świadczonych przez pośrednictwem PeP. Upoważnienie udzielane jest na czas obowiązywania Umowy PLAT i 12 miesięcy po zakończeniu współpracy w oparciu o Umowę PLAT \n\noraz potwierdzam, iż powyższa zgoda jest wyrażona wyłącznie w odniesieniu do tych dostawców usług płatniczych (odpowiednio PayPro S.A. i / lub Polskie ePłatności sp. z o.o. z siedzibą w Rzeszowie) z którymi na dzień wyrażania niniejszej zgody wiąże mnie umowa o świadczenie usług płatniczych.',
                    },
                    pragmaGoDataProcessing: {
                        title: 'Upoważniam PragmaGO S.A. do przekazywania danych do PayPro S.A. i / lub Polskie ePłatności sp. z o.o',
                        content: 'Upoważniam PragmaGO S.A. z siedzibą w Katowicach do przekazywania do tych z poniższych podmiotów (odpowiednio PayPro S.A. z siedzibą w Poznaniui / lub Polskie ePłatności sp. z o.o. z siedzibą w Rzeszowie ), z którymi łączy mnie umowa o świadczenie usług płatniczych, to jest:\n\n1. PayPro S.A. z siedzibą w Poznaniu następujących informacji dotyczących łączącej mnie z PragmaGO z siedzibą w Katowicach Umowy Zaliczki Przychodowej (Umowy Pożyczki - PragmaGO x Przelewy24 Finance), a także wszelkich aneksów i porozumień do Umowa Pożyczki - PragmaGO x Przelewy24 Finance: Umowa Pożyczki - PragmaGO x Przelewy24 Finance, w tym aneksów i porozumień do Umowy Pożyczki - PragmaGO x Przelewy24 Finance, a także informacji o sposobie jej wykonywania: oceny zdolności kredytowej dokonanej przez PragmaGO z siedzibą w Katowicach, wysokości nadanego Klientowi limitu finansowego, możliwości świadczenia usług finansowania na podstawie Umowy Pożyczki - PragmaGO x Przelewy24 Finance, przyczynę odmowy świadczenia usług finansowania, zawarciu, zmianie, rozwiązaniu lub wygaśnięciu Umowy Pożyczki - PragmaGO x Przelewy24 Finance oraz okolicznościach uzasadniających to zdarzenie lub towarzyszącym temu zdarzeniu celem ujawnienia ci tych danych w Systemie oraz realizacji Cesji. Upoważnienie udzielane jest na czas obowiązywania Umowy Pożyczki - PragmaGO x Przelewy24 Finance i 6 miesięcy po zakończeniu współpracy w oparciu o Umowę Pożyczki - PragmaGO x Przelewy24 Finance.\n\ni / lub\n\n2. Polskie ePłatności sp. z o.o. z siedzibą w Rzeszowie następujących informacji dotyczących łączącej mnie z PragmaGO z siedzibą w Katowicach Umowy Zaliczki Przychodowej (Umowa Pożyczki), a także wszelkich aneksów i porozumień do Umowy Pożyczki: Umowy Pożyczki, w tym aneksów i porozumień do Umowy Pożyczki, a także informacji o sposobie jej wykonywania: oceny zdolności kredytowej dokonanej przez PragmaGO z siedzibą w Katowicach, wysokości nadanego Klientowi limitu finansowego, możliwości świadczenia usług finansowania na podstawie Umowy Pożyczki, przyczynę odmowy świadczenia usług finansowania, zawarciu, zmianie, rozwiązaniu lub wygaśnięciu Umowy Pożyczki oraz okolicznościach uzasadniających to zdarzenie lub towarzyszącym temu zdarzeniu celem ujawnienia ci tych danych w Systemie oraz realizacji Dyspozycji. Upoważnienie udzielane jest na czas obowiązywania Umowy Pożyczki i 6 miesięcy po zakończeniu współpracy w oparciu o Umowę Pożyczki\n\noraz potwierdzam, iż powyższa zgoda jest wyrażona wyłącznie w odniesieniu do tych dostawców usług płatniczych (odpowiednio PayPro S.A. z siedzibą w Poznaniu i / lub Polskie ePłatności sp. z o.o. z siedzibą w Rzeszowie) z którymi na dzień wyrażania niniejszej zgody wiąże mnie umowa o świadczenie usług płatniczych.',
                    },
                    plCitizen: 'Oświadczam, że posiadam obywatelstwo polskie zgodnie z obowiązującymi przepisami prawa Rzeczypospolitej Polskiej.',
                    pep: 'Oświadczam, że nie zajmuję eksponowanego stanowiska politycznego (PEP).',
                },
            },
        },
        button: 'Składam wniosek',
        fundingProvider: 'Finansowanie zapewnia:',
        specialOffer: {
            banner: {
                title: 'Oferta ważna jeszcze tylko',
                disclaimer: '*lub do wyczerpania puli środków',
                forCompanyGrow: 'na rozwój Twojej firmy',
                withInterestOnly: 'z oprocentowaniem tylko',
                limitedOffer: 'Oferta limitowana',
            },
            bannerVariant5: {
                title: 'Przekonaj się jakie to wygodne',
                description: 'Skorzystaj jednorazowo z finansowego STARTERA 2X2 dla Twojego biznesu.',
                months: 'm-ce',
            },
        },
        autoPeriodChange: 'Okres spłaty został zmieniony automatycznie.',
        autoAmountChange: 'Kwota została zmieniona automatycznie.',
    },
    selectOfferPage: {
        offerForm: {
            loanAmount: 'Kwota finansowania',
            loanConditions: 'Warunki finansowania',
            financingConditions: 'Warunki finansowania',
            offerAdvanceAmount: {
                youAreRequesting: 'Wnioskujesz o',
                description: 'Wybierz czas spłaty i zobacz jakie otrzymasz warunki finansowania.',
                min: 'min',
                max: 'max',
                button: 'Zmień kwotę',
                secondDescription: {
                    maxAmount: 'Maksymalna kwota o jaką możesz zawnioskować, to {{amount}} PLN',
                    basedOnTurnover: 'Wyliczono na podstawie obrotów w Przelewy24',
                },
            },
            autoPeriodChange: 'Okres spłaty został zmieniony automatycznie.',
            autoAmountChange: 'Kwota została zmieniona automatycznie.',
            multiprovider: {
                fetchOffersDescription: 'Uzupełnij danie i wnioskuj nawet o <0>{{ amount }} PLN</0>',
                moreOffers: 'Więcej ofert',
                noAvailableOffersModal: {
                    title: 'Brak nowych ofert ale...',
                    description: 'Aktualne oferty wciąż czekają! Kliknij i zobacz, które z nich najlepiej pasują do Twoich potrzeb.',
                    button: 'Wróć do dostępnych ofert',
                },
            },
        },
        limitIncreaseBanner: {
            availableAmountBadge: {
                title: 'Dostępna kwota',
            },
            availableLimitIncreased: 'Dostępny limit został podniesiony',
            youCanEvenApplyFor: 'Możesz zawnioskować nawet o:',
            buttonText: 'Zwiększam kwotę wniosku',
            multiprovider: {
                availableAmountBadge: {
                    title: 'Oferta dla Ciebie',
                },
                newOfferAvailableHigherAmount: {
                    title: 'Nowe oferty! Uzupełnij dane i sprawdź!',
                    description: 'Jeśli chcesz sprawdzić ofertę innych firm, wyraź zgody na indywidualna ocenę zdolności finansowej. Oferta wstępna dostawcy Liberis to aż:',
                    buttonText: 'Sprawdzam oferty',
                },
                availableHigherAmount: {
                    title: 'Masz dostęp do większej kwoty!',
                    description: 'Możesz zawnioskować nawet o:',
                    buttonText: 'Zwiększam kwotę wniosku',
                },
            },
        },
        financingProvides: 'Finansowanie zapewnia',
        loanDetails: {
            firstCard: {
                title: 'Prowizja',
            },
            secondCard: {
                title: 'Spłata',
                description: 'obrotów w Przelewy24',
            },
            thirdCard: {
                title: 'Całkowita kwota spłaty',
                description: 'Zawiera koszt',
            },
        },
        button: 'Składam wniosek',
        fundingProvider: 'Finansowanie zapewnia:',
        multiprovider: {
            chooseMaxTenor: 'Wybierz maksymalny okres spłaty',
            modal: {
                pragma: {
                    title: 'Zaznacz zgody, aby złożyć wniosek:',
                    backButton: 'Wróć',
                    submitButton: 'Składam wniosek',
                    confirmButton: 'Potwierdzam i idę dalej',
                },
            },
        },
    },
    loanProcess: {
        loanSteps: {
            application: {
                processing: {
                    title: 'Weryfikujemy Twój wniosek',
                    description: 'Nie zamykaj okna przeglądarki',
                },
                positive: {
                    title: {
                        success: 'Świetnie,',
                        applicationSucceed: 'wniosek rozpatrzony pozytywnie',
                    },
                    description: 'W następnym kroku zobaczysz podsumowanie. Zapoznaj się z dokumentami i podpisz umowę, wpisując kod SMS, który do Ciebie wysłaliśmy.',
                    leaveOrIncreaseAmount: {
                        title: 'Możesz skorzystać z wybranej kwoty lub ją zwiększyć.',
                        newMaxAmount: 'Nowa maksymalna kwota finansowania:',
                    },
                    button: {
                        default: 'Przejdź do podsumowania',
                        increaseAmount: 'Zwiększam kwotę',
                        keepCurrentAmount: 'Kontynuuję wcześniejszy wybór',
                    },
                },
                negative: {
                    title: 'Przykro nam, wniosek rozpatrzony negatywnie',
                    button: 'Powrót',
                },
                suspended: {
                    title: 'Coś poszło nie tak',
                    description: {
                        sorryTechnicalErrorHasOccured: 'Przepraszamy, nastąpił błąd techniczny.',
                        tryAgainLater: 'Spróbuj ponownie później.',
                    },
                    errorCode: 'Kod błędu:',
                    button: 'Powrót',
                },
                loanAmountChange: {
                    title: 'Kwota finansowanie uległa zmianie',
                    newLimitDescription: 'Po weryfikacji Twojej zdolności limit zmniejszył się do',
                    possibleAmount: 'Możliwa kwota finansowania',
                    doYouWantContinue: 'Czy chcesz kontynuować?',
                    button: {
                        continue: 'Tak, chcę kontynuować',
                        cancel: 'Nie, anuluję wniosek',
                    },
                },
                howDoYouKnowAboutP24Financing: {
                    title: 'Skąd masz informacje o',
                    productTitle: 'Przelewy24 Finance?',
                    description: 'Twoja opinia pozwoli nam lepiej dostosować naszą ofertę. Wybierz źródło informacji z listy rozwijalnej.',
                    form: {
                        select: {
                            options: {
                                p24Website: 'Strona internetowa przelewy24.pl',
                                p24TransactionPanel: 'Panel transakcyjny Przelewy24',
                                p24Email: 'Wiadomość e-mail od Przelewy24',
                                p24TalkWithConsultant: 'Rozmowa z opiekunem handlowym w Przelewy24',
                            },
                            label: 'Wybierz źródło informacji o finansowaniu',
                        },
                        button: 'WYŚLIJ ODPOWIEDŹ',
                        validation: {
                            source: 'Wybierz jedno źródło informacji o finansowaniu',
                        },
                    },
                },
                blockNewApplicationSubmit: {
                    title: {
                        apologise: 'Przykro nam,',
                        reason: 'w tej chwili nie ma możliwości złożenia wniosku.',
                    },
                    description: 'Spróbuj ponownie za kilka minut',
                    button: 'Powrót',
                },
            },
            agreementAndApprovals: {
                summary: {
                    title: 'Podsumowanie wniosku',
                    advancedAmount: {
                        title: 'Otrzymasz kwotę',
                        button: 'Zmień',
                        edit: {
                            cancel: 'Anuluj',
                            confirm: 'Zatwierdź zmiany',
                        },
                    },
                    details: {
                        repaymentPeriod: 'Okres spłaty',
                        interestRates: 'Prowizja',
                        payoff: 'Spłata (% obrotów w Przelewy24)',
                        loanCost: 'Koszt finansowania',
                        totalRepaymentAmount: 'Całkowita kwota spłaty',
                        costIncluded: 'Zawiera koszt',
                        months: 'do {{number}} miesięcy',
                    },
                },
                documents: {
                    title: 'Pobierz dokument',
                    documentTitle: 'Umowa pożyczki PragmaGO x Przelewy24 Finance',
                    error: 'Wystąpił błąd podczas pobierania pliku. Spróbuj ponownie.',
                },
                loanRepayment: {
                    title: 'Twoje konta w Przelewy24',
                    description: 'Spłata nastąpi z obrotów generowanych na wszystkich kontach zarejestrowanych na nr NIP Twojej firmy.',
                    form: {
                        fields: {
                            merchantId: 'ID Merchanta',
                        },
                    },
                },
                button: 'Akceptuje umowę i regulamin',
                liberisButton: 'Potwierdzam złożenie wniosku',
                processing: {
                    title: 'Trwa przetwarzanie umowy',
                    description: 'Nie zamykaj okna przeglądarki',
                },
            },
            successfulSigned: {
                title: 'Umowa została podpisana',
                description: 'Pieniądze pojawią się na Twoim koncie najpóźniej w kolejnym dniu roboczym.',
                button: 'gotowe',
            },
            sms: {
                confirmation: {
                    title: 'Zaakceptuj umowę, wpisując kod SMS',
                    description: 'Siedmiocyfrowy kod wysłaliśmy na numer',
                    enterSmsCode: 'Wprowadź SMS nr {{number}}',
                    sendSmsCodeAgain: 'Wyślij kod ponownie',
                    on: 'za',
                    button: 'Podpisuję umowę',
                    form: {
                        validation: {
                            sms: 'Nieprawidłowy kod SMS',
                        },
                    },
                },
                tooManyAttempts: {
                    title: {
                        wrongSMSCode: 'Błędny kod SMS.',
                        limit: 'Limit prób podpisania umowy został wyczerpany',
                    },
                    description: 'Za chwilę nastąpi przekierowanie do Panelu Finansowania. Proces wnioskowania został tymczasowo zablokowany. Możesz go rozpocząć ponownie po zdjęciu blokady, czyli po upływie 24h.',
                    button: 'Powrót do strony głównej',
                },
            },
        },
    },
    dashboard: {
        faqCard: {
            title: 'Najczęściej zadawane pytania',
        },
        merchantLimitCard: {
            title: 'Twój aktualny limit',
            subtitle: 'Kwota, o którą możesz zawnioskować:',
            info: 'Limit obliczamy na podstawie kilku czynników, m.in. wysokości Twoich obrotów w Przelewy24, dlatego może on ulec zmianie. Więcej informacji znajdziesz w',
            usedLimit: 'Wykorzystany limit',
            minLoanAmount: 'Min. finansowanie',
            obtainedLimit: 'Przyznany limit',
            limitToUse: 'Limit do wykorzystania',
            faq: 'FAQ',
        },
        paymentHistory: {
            title: 'Spłaty',
            emptyHistory: 'Tu pojawi się lista spłat Twoich wniosków o finansowanie',
            headers: {
                date: 'DATA',
                accountId: 'ID KONTA',
                amount: 'KWOTA',
            },
            loadMore: 'Pokaż kolejne',
            date: 'Data: ',
        },
        loanActionCard: {
            logoImage: {
                alt: 'PragmaGO & Przelewy24',
            },
            image: {
                alt: 'Loan action card theme image',
            },
            hero: {
                newPossibilities: 'Nowe możliwości',
                ofFinancingYourCompany: 'finansowania dla Twojej firmy',
            },
            description: {
                insufficientPrivileges: 'Usługa jest dostępna na koncie z wyższym poziomem uprawnień. Przeloguj się na konto "User"',
                insufficientLoanLimit: 'Aktualny limit na Twoim koncie nie pozwala na przyznanie dodatkowego finansowania.',
                activePragmaApplication: 'Aktualny limit na Twoim koncie nie pozwala na przyznanie dodatkowego finansowania.',
                activeLiberisApplication: 'Aktualny limit na Twoim koncie nie pozwala na przyznanie dodatkowego finansowania.',
                acquireFunds: 'Pozyskaj środki na rozwój biznesu lub dowolny inny cel. Spłacaj wygodnie, z obrotów generowanych na kontach w Przelewy24.',
                liberisNotificationPending: 'Dostawca finansowania przeprowadza końcową weryfikację kompletności i poprawności wniosku oraz dokumentów. Dostawca może się kontaktować w przypadku potrzeby uzupełnienia informacji lub wyjaśnień.',
                liberisLoanNotRepaid: 'Obecnie masz aktywne finansowanie, dlatego nie możesz skorzystać z pozostałej części dostępnego limitu. <0></0> Aby uzyskać nowe finansowanie, konieczne jest <1>spłacenie obecnego zobowiązania.</1> Po jego spłacie, automatycznie otworzy się możliwość skorzystania z kolejnej oferty w ramach przyznanego limitu.',
            },
            buttons: {
                finishApplication: 'Dokończ wnioskowanie',
                makeNewApplication: 'Złóż nowy wniosek',
            },
            modal: {
                title: 'Nowy wniosek o finansowanie',
                subtitle: 'Pamiętaj, złożenie nowego wniosku spowoduje anulowanie aktualnego.',
                finishCurrentApplication: 'Dokończ aktualny wniosek',
            },
        },
        loanList: {
            yourLoans: 'Twoje wnioski o finansowanie',
            yourLoansWillAppearThere: 'Tu pojawią się Twoje wnioski o finansowanie',
            list: {
                badge: {
                    applicationCanceled: 'Wniosek anulowany',
                    loanDecission: 'Decyzja dotycząca finansowania',
                    acceptTerms: 'Akceptacja warunków',
                    signment: 'Podpis klienta',
                    applicationVerification: 'Weryfikacja wniosku',
                    launchingFinancialResources: 'Uruchomienie środków',
                    applicationSubmitted: 'Wniosek przedawniony',
                },
            },
            details: {
                applicationDetails: 'Szczegóły wniosku',
                loanNumberId: 'Finansowanie nr ID',
                downloadAgreement: 'Pobierz umowę',
                downloadDocumentError: 'Wystąpił błąd podczas pobierania pliku. Spróbuj ponownie.',
                document: 'Dokument',
                steps: {
                    firstLoanDecision: {
                        name: 'Decyzja dotycząca finansowania',
                        messages: {
                            current: 'Trwa oczekiwanie na decyzję dotyczącą finansowania.',
                            failedTechnicalError: 'Podczas oczekiwania na decyzję dotyczącą finansowania pojawił się błąd techniczny. Aby uzyskać finansowanie, <0>złóż nowy wniosek</0>',
                            limitToSmall: 'Aktualny limit na Twoim koncie nie pozwala na złożenie nowego wniosku.',
                            failedCannotMakeAnyOffer: 'Obecnie nie możemy zaproponować Twojej firmie finansowania. Wniosek został odrzucony z powodu',
                            failedCannotMakeAnyOfferFaq: '<0>Sprawdź FAQ</0>, żeby dowiedzieć się więcej.',
                        },
                    },
                    secondAcceptTerms: {
                        name: 'Akceptacja warunków',
                        messages: {
                            current: 'Aby dokończyć proces wnioskowania o finansowanie <0>zaakceptuj warunki umowy</0>. Jeśli chcesz zrezygnować, <1>anuluj wniosek.</1>',
                            currentLiberis: 'Aby dokończyć proces wnioskowania o finansowanie <0>zaakceptuj warunki umowy</0>.',
                            failedTimeRunOut: 'Upłynął termin 5 dni na dokończenie wniosku. Warunki umowy nie zostały przez Ciebie zaakceptowane. Jeśli chcesz pozyskać finansowanie, <0>złóż nowy wniosek.</0>',
                            failedCanceledByUser: 'Wniosek został anulowany. Jeżeli chcesz pozyskać finansowanie <0>złóż nowy wniosek</0>',
                            loanAmountChange: 'Po weryfikacji Twojej zdolności limit został zmniejszony. Aby uzyskać finansowanie <0>zaakceptuj warunki umowy</0>. Jeśli chcesz zrezygnować, <1>anuluj wniosek.</1>',
                            limitToSmall: 'Aktualny limit na Twoim koncie nie pozwala na złożenie nowego wniosku.',
                        },
                    },
                    thirdSigning: {
                        name: 'Podpis klienta',
                        applicationVerification: 'Weryfikacja wniosku',
                        messages: {
                            currentStageFour: 'Aby uzyskać finansowanie <0>podpisz umowę kodem SMS</0>. Jeśli chcesz zrezygnować, <1>anuluj wniosek</1>.',
                            currentTooManyAttempts: 'Kod SMS został wpisany błędnie zbyt wiele razy. Ze względów bezpieczeństwa powrót do wniosku będzie możliwy następnego dnia po ostatniej próbie wpisania kodu SMS. Jeśli chcesz zrezygnować, <0>anuluj wniosek.</0>',
                            currentStageThree: 'Aby uzyskać finansowanie <0>wróć do wniosku</0>. Jeśli chcesz zrezygnować, <1>anuluj wniosek</1>.',
                            failedTimeRunOut: 'Upłynął termin 5 dni na dokończenie procesu. Wniosek został anulowany ze względu na brak podpisania umowy kodem SMS. Jeśli chcesz pozyskać finansowanie, <0>złóż nowy wniosek.</0>',
                            failedTimeRunOutLiberis: 'Upłynął termin na dokończenie procesu. Wniosek został anulowany. Jeśli chcesz pozyskać finansowanie, <0>złóż nowy wniosek.</0>',
                            failedCanceledByUser: 'Wniosek został anulowany. Jeżeli chcesz pozyskać finansowanie <0>złóż nowy wniosek</0>',
                            limitToSmall: 'Aktualny limit na Twoim koncie nie pozwala na złożenie nowego wniosku.',
                            liberisNotificationPending: 'Dostawca finansowania przeprowadza końcową weryfikację kompletności i poprawności wniosku oraz dokumentów. Dostawca może się kontaktować w przypadku potrzeby uzupełnienia informacji lub wyjaśnień.',
                        },
                    },
                    fourthLaunchingFinancialResources: {
                        name: 'Uruchomienie środków',
                        messages: {
                            finished: 'Gratulacje. Twój wniosek o finansowanie został zaakceptowany. Pieniądze pojawią się na wskazanym przez Ciebie rachunku bankowym najpóźniej w kolejnym dniu roboczym.',
                        },
                    },
                },
            },
            cancelModal: {
                title: 'Anulowanie wniosku',
                subtitle: 'Twój wniosek o finansowanie jest aktywny i czeka na dokończenie.',
                question: 'Czy na pewno chcesz go anulować?',
                cancelButton: 'Chcę anulować wniosek',
                continueButton: 'Chcę dokończyć wniosek',
            },
            whyDoYouCancelLoanModal: {
                title: 'Dlaczego anulujesz wniosek o finansowanie?',
                description: 'Powiedz nam dlaczego chcesz anulować wniosek o finansowanie. Wybierz powód z listy rozwijalnej.',
                form: {
                    select: {
                        options: {
                            doNotNeedThatMoney: 'Nie potrzebuję tych środków',
                            justCheckingMyAbility: 'Tylko sprawdzam swoją zdolność',
                            conditionsAreNotFavorableForMe: 'Warunki nie są dla mnie korzystne',
                            preferLoanFromBank: 'Wolę finansowanie w banku',
                        },
                        label: 'Wybierz powód anulowania wniosku',
                    },
                    button: 'PRZEŚLIJ ODPOWIEDŹ',
                    validation: {
                        reason: 'Wybierz jeden powód anulowania wniosku',
                    },
                },
                errorOccurred: 'Wystąpił niespodziewany błąd. Kod błędu:',
            },
        },
    },
    validation: {
        required: 'Pole obowiązkowe',
        min: 'Proszę podać więcej niż {{count}} znaków',
        max: 'Pole może zawierać max {{count}} znaków',
    },
    errors: {
        unknown: 'Nieznany błąd',
        withInfoCode: 'Wystąpił błąd - kod błędu {{ code }}',
    },
    components: {
        multiSelect: {
            allFields: 'Wszystkie',
            andMore: '(i {{number}} więcej)',
        },
        breadcrumb: {
            back: 'Cofnij',
        },
        specialOfferCountdown: {
            days: 'dni',
            hours: 'godz.',
            minutes: 'min',
            seconds: 'sek',
        },
        amountSelector: {
            maxAmountExceed: 'Maksymalna kwota o jaką możesz zawnioskować, to {{max}} zł',
            minAmountFallShort: 'Minimalna kwota o jaką możesz zawnioskować, to {{min}} zł',
        },
        recipientNotification: {
            fieldsNotification: {
                default: 'Poniższe dane zostały wprowadzone podczas rejestracji konta w Przelewy24.',
                warning: {
                    phone: 'Uzupełnij swoje dane o numer telefonu, na który prześlemy kod SMS potrzebny do zaakceptowania umowy.',
                    mail: 'Ostrzeżenie o konieczności podania Emaila',
                },
                error: {
                    phone: 'Uzupełnij swoje dane o numer telefonu, na który prześlemy kod SMS potrzebny do zaakceptowania umowy.',
                    mail: 'Uzupełnij swoje dane o adres email, który jest niezbędny do złożenia wniosku dotyczącego finansowania.',
                    phoneAndMail: 'Uzupełnij swoje dane o numer telefonu oraz adres email, które są niezbędne do złożenia wniosku dotyczącego finansowania.',
                    polishIdOrPesel: 'Dane reprezentanta są nieprawidłowe. Aby je zmienić, skontaktuj się z Biurem Obsługi Biznesu.',
                },
            },
        },
        agreements: {
            validation: 'Zaznacz wymagane zgody',
            checkAll: 'Zaznacz wszystkie',
            openModalButton: 'Rozwiń',
        },
        loanDetails: {
            firstCard: {
                title: 'Prowizja',
                specialOfferTitle: 'Oprocentowanie całkowite',
            },
            secondCard: {
                title: 'Spłata',
                description: 'obrotów w Przelewy24',
            },
            thirdCard: {
                title: 'Całkowita kwota spłaty',
                description: 'Zawiera koszt',
            },
        },
        repaymentPeriod: {
            title: 'Wybierz czas spłaty',
            radioName: 'do {{number}} miesięcy',
            new: 'NOWA',
        },
        loanProvider: {
            title: 'Wybierz dostawcę',
        },
    },
    togglePlayground: {
        active: 'Exit playground mode',
        unActive: 'Change to Playground',
    },
    widget: {
        altDefault: 'Pragma x Przelewy24',
        ribbon: 'NOWOŚĆ',
        variantChips: {
            decision: 'decyzja w 90s',
            amount: 'do 1 200 000 PLN',
            repayment: 'automatyczna spłata',
        },
        amountSlider: {
            label: 'Możesz wnioskować o:',
            min: 'min. {{amount}} {{currency}}',
            max: 'max: {{amount}} {{currency}}',
        },
        views: {
            WidgetHas0Prelimit: {
                header: 'Szybkie finansowanie dla Twojej firmy',
                label: 'Raty pod kontrolą Twoich obrotów do:',
                currency: 'PLN',
                button: 'CHCĘ SKORZYSTAĆ',
                variant: {
                    title: 'Finansowanie dla Twojej firmy',
                    paragraph1: 'Obecnie Twoje obroty w Przelewy24 nie pozwalają na przyznanie finansowania.',
                    paragraph2: 'Spokojnie, regularnie je analizujemy i w przyszłości mogą pojawić się dla Ciebie nowe opcje.',
                    faqPrefix: 'Sprawdź zasady w ',
                    faqLink: 'FAQ',
                },
                extraSmall: {
                    header: 'Do {{amount}} PLN',
                    subHeader: 'dla Twojej firmy',
                },
            },
            WidgetHasLessThan3000Limit: {
                header: 'Finansowanie dla Twojej firmy',
                label: 'Aktualny limit na Twoim koncie nie pozwala na przyznanie dodatkowego finansowania.',
                variantDescription: 'Twój limit jest niższy niż minimalna kwota finansowania (3 000 zł). Spokojnie - spłacasz zobowiązania na bieżąco, więc limit zaraz się odnowi i znów dobierzesz środki.',
                button: 'WIĘCEJ INFORMACJI',
            },
            WidgetHasOver0PrelimitAndNoLimit: {
                header: 'Finansowanie dla Twojej firmy',
                label: 'Aktualny limit pozwala na złożenie wniosku do:',
                button: 'WEŹ POŻYCZKĘ',
                variant1: {
                    headline: 'Odpocznij.',
                    subheadline: 'Twoje finanse są bezpieczne.',
                    description: 'Skorzystaj z elastycznego finansowania dla Twojego biznesu',
                    button: 'SKORZYSTAJ Z FINANSOWANIA',
                },
                variant2: {
                    headline: 'Finansowanie dla Twojej firmy',
                    description: 'Twoje obroty pozwalają na złożenie wniosku o kolejne środki w wysokości:',
                    button: 'SKORZYSTAJ Z FINANSOWANIA',
                },
                extraSmall: {
                    header: 'Do {{amount}} PLN',
                    subHeader: 'dla Twojej firmy',
                    variant5: {
                        header: 'Starter finansowy',
                        subHeader: 'dla Twojego biznesu',
                        repayment: 'spłata w 2 m-ce',
                        button: 'Sprawdź teraz',
                    },
                },
                specialOffer: {
                    title: 'Oferta specjalna',
                    countdownWidget: 'Oferta ważna jeszcze tylko',
                    limitedQuantitySection: {
                        limitedPool: 'Ograniczona pula!',
                        forGrowthYourCompany: 'na rozwój Twojej firmy',
                        with: 'z',
                        interestRate: 'oprocentowaniem',
                        only: 'tylko',
                    },
                    takeSpecialOffer: 'SKORZYSTAJ Z OFERTY SPECJALNEJ',
                    apply: 'Złóż wniosek',
                    financingForYourCompanySection: {
                        title: 'Finansowanie dla Twojej firmy',
                        description: 'Pozyskaj środki na rozwój swojego biznesu lub dowolny inny cel. Spłacaj wygodnie, z obrotów generowanych w Przelewy24.',
                    },
                    specialOfferSection: {
                        forCompanyGrow: 'na rozwój Twojej firmy',
                        withInterestOnly: 'z oprocentowaniem tylko',
                        limitedOffer: 'OFERTA WAŻNA DO WYCZERPANIA PULI ŚRODKÓW',
                    },
                    extraSmall: {
                        header: 'Oferta specjalna',
                        forCompanyGrow: 'na rozwój Twojej firmy',
                        withInterestOnly: 'z oprocentowaniem tylko',
                    },
                },
                variant5: {
                    title: 'Przekonaj się',
                    titleSecondLine: 'jakie to wygodne',
                    description: 'Skorzystaj jednorazowo z finansowego',
                    starter: 'STARTERA 2x2',
                    descriptionSuffix: 'dla Twojego biznesu.',
                    amountPrefix: 'do',
                },
            },
            WidgetHasNoRequiredRights: {
                header: 'Finansowanie dla Twojej firmy',
                label: 'Usługa jest dostępna na koncie z wyższym poziomem uprawnień. Przeloguj się na odpowiednie konto.',
            },
            WidgetHasActiveLoanApplication: {
                header: 'Twój wniosek dotyczący finansowania',
                label: 'Kontynuuj proces wnioskowania o dodatkowe środki dla Twojej firmy lub na inny, dowolny cel.',
                requestingAbout: 'WNIOSKUJESZ O:',
                currency: 'PLN',
                button: 'DOKOŃCZ WNIOSEK',
                variant1: {
                    header: 'Twój wniosek pożyczkowy',
                    label: 'Dokończ wniosek o dodatkowe środki dla Twojej firmy lub na inny, dowolny cel.',
                },
            },
            WidgetHasOver3000LimitAndNoLoanApplication: {
                header: 'Finansowanie dla Twojej firmy',
                newPossibilities: 'NOWE MOŻLIWOŚCI',
                label: 'Twój limit pozwala na złożenie kolejnego wniosku w wysokości:',
                currency: 'PLN',
                button: 'WEŹ POŻYCZKĘ',
                extraSmall: {
                    header: 'Do {{amount}} PLN',
                    subHeader: 'dla Twojej firmy',
                },
                variant1: {
                    label: 'Twoje obroty pozwalają na złożenie wniosku o kolejne środki w wysokości:',
                    button: 'SKORZYSTAJ Z FINANSOWANIA',
                },
            },
            WidgetServiceNotAvailable: {
                header: 'Usługa chwilowo niedostępna',
                label: 'Wróć za chwilę',
            },
            WidgetTooManySmsAttempts: {
                header: 'Twój wniosek dotyczący finansowania',
                label: 'aktualnie jest zablokowany z powodu wielokrotnego wpisania niepoprawnego kodu SMS. Blokada zostanie zdjęta kolejnego dnia.',
                requestingAbout: 'WNIOSKUJESZ O:',
                currency: 'PLN',
                button: 'WIĘCEJ INFORMACJI',
            },
        },
    },
    errorBoundary: {
        title: 'Usługa chwilowo niedostępna',
        description: 'Wróć za chwilę i złóż wniosek.',
    },
    countries: {
        austria: 'Austria',
        canada: 'Kanada',
        czech_republic: 'Czechy',
        germany: 'Niemcy',
        denmark: 'Dania',
        england: 'Anglia',
        finland: 'Finlandia',
        united_kingdom: 'Wielka Brytania',
        ireland: 'Irlandia',
        iceland: 'Islandia',
        poland: 'Polska',
        sweden: 'Szwecja',
        slovakia: 'Słowacja',
        united_states: 'Stany Zjednoczone',
    },
    promotionCode: {
        buttonText: 'Czy ktoś polecił Ci tę usługę?',
        submitButtonText: 'Zatwierdź',
        errorModal: {
            closeButton: 'Wróć do dostępnych ofert',
        },
        validation: {
            codeRequired: 'Pole obowiązkowe',
        },
        errors: {
            INVALID_CODE: {
                title: 'Ups, nie znamy takiego kodu.',
                description: 'Sprawdź pisownię lub skontaktuj się z polecającym.',
            },
            INACTIVE: {
                title: 'Ups, ten kod wygląda na nieaktywny.',
                description: 'Możesz kontynuować bez niego.',
            },
            INVALID_OFFER: {
                title: 'Ten kod jest przeznaczony dla innego typu oferty.',
                description: 'Automatycznie ustawiliśmy dostępną ofertę.',
            },
            CODE_NOT_YET_ENABLED: {
                title: 'Falstart!',
                description: 'Ten kod jeszcze nie działa, ale będzie aktywny już wkrótce.',
            },
            CODE_EXPIRED: {
                title: 'Niewiele brakowało',
                description: 'Niestety ten kod jest już nieważny.',
            },
            USED: {
                title: 'Ups, ten kod został już wyczerpany',
                description: 'Chyba był bardzo rozchwytywany.',
            },
            LOAN_AMOUNT_TO_HIGH: {
                title: 'Super!',
                description: 'Z tym kodem możesz skorzystać z promocji do kwoty {{amount}} zł. Automatycznie ustawiliśmy maksymalną kwotę wniosku.',
            },
            LOAN_AMOUNT_TO_LOW: {
                title: 'Super!',
                description: 'Z tym kodem możesz skorzystać z promocji od kwoty {{amount}} zł. Automatycznie ustawiliśmy minimalną kwotę wniosku.',
            },
            FIRST_LOAN: {
                title: 'Witaj ponownie!',
                description: 'Ten kod działa tylko na pierwszą pożyczkę, ale możesz kontynuować bez niego.',
            },
            NEXT_LOAN: {
                title: 'Ten kod działa tylko na kolejną pożyczkę,',
                description: 'ale możesz kontynuować bez niego.',
            },
            PRICING_TOO_LOW: {
                title: 'Ten kod jest przeznaczony dla innego typu oferty.',
                description: 'Automatycznie ustawiliśmy dostępną ofertę.',
            },
        },
    },
};
